import React, { useState, useEffect, useRef } from 'react';
import { fetchConToken } from 'helpers/fetch';
import { getDataSession } from 'views/Utils/Common';
import { alertService } from '_services';
import { Link } from 'react-router-dom';
import { useGlobalState } from 'resources/GlobalStateContext';
import Swal from 'sweetalert2';

const Ver = ({ match }) => {
    const { setGlobalTitulo } = useGlobalState();
    const { id } = match.params;
    const isAddMode = !id;
    let [data, setData] = useState({});
    const dataCanceladoRef = useRef(data?.cancelado);
    
    useEffect(() => { if (dataCanceladoRef) dataCanceladoRef.current = data?.cancelado; }, [data?.cancelado]);

    useEffect(() => {
        async function getMovimiento() {
            const mov = await fetchConToken(`existencias/MovimientoInventario?id=${id}&sucursal_Id=${getDataSession('sucursal')}`);
            setData(mov);
        }

        setGlobalTitulo(prev => ({
            ...prev,
            titulo: 'Movimiento',
            subtitulo: 'Estatus: ' + (dataCanceladoRef.current === 'N' ? "Activo" : "Cancelado")
        }));
        getMovimiento();
    }, [setGlobalTitulo, id]);

    function Cancelar() {
        Swal.fire({
            text: '¿Desea cancelar la venta?',
            showCancelButton: true,
            confirmButtonText: 'Si,Cancelar',
            cancelButtonText: 'No'
        }).then((result) => {
            if (result.isConfirmed) fetchConToken(`existencias/MovimientoInventario?&sucursal_Id=${getDataSession('sucursal')}&id=` + id, null, 'DELETE').then((response) => {
                if (response.hasOwnProperty('status')) {
                    Object.entries(response.errors).forEach(([, value]) => {
                        Swal.fire('Error', value[0], 'error');
                    });
                    return false;
                } else if (response.hasOwnProperty('codigo')) {
                    Swal.fire('Error', response.mensajes[0], 'error');
                    return;
                }
                Swal.fire('Exito', 'Cancelado Correctamente', 'success');
            }).catch(alertService.error);
        })

    }

    return (<>
        <div className='container-fluid'>
            <div className='row'>
                <div className='col-md-12 text-right'>
                    &nbsp;
                    {data?.cancelado === 'N' ? <>
                        <button
                            className='btn btn-outline-success'
                            onClick={(e) => Cancelar()}
                            type='button'
                        >
                            &nbsp; Cancelar
                        </button>&nbsp;
                    </> : ''}
                    <Link to={isAddMode ? '.' : '..'} className='btn btn-outline-warning'>
                        <svg
                            xmlns='http://www.w3.org/2000/svg'
                            width='15'
                            height='15'
                            fill='currentColor'
                            className='bi bi-reply'
                            viewBox='0 0 16 16'
                        >
                            <path d='M6.598 5.013a.144.144 0 0 1 .202.134V6.3a.5.5 0 0 0 .5.5c.667 0 2.013.005 3.3.822.984.624 1.99 1.76 2.595 3.876-1.02-.983-2.185-1.516-3.205-1.799a8.74 8.74 0 0 0-1.921-.306 7.404 7.404 0 0 0-.798.008h-.013l-.005.001h-.001L7.3 9.9l-.05-.498a.5.5 0 0 0-.45.498v1.153c0 .108-.11.176-.202.134L2.614 8.254a.503.503 0 0 0-.042-.028.147.147 0 0 1 0-.252.499.499 0 0 0 .042-.028l3.984-2.933zM7.8 10.386c.068 0 .143.003.223.006.434.02 1.034.086 1.7.271 1.326.368 2.896 1.202 3.94 3.08a.5.5 0 0 0 .933-.305c-.464-3.71-1.886-5.662-3.46-6.66-1.245-.79-2.527-.942-3.336-.971v-.66a1.144 1.144 0 0 0-1.767-.96l-3.994 2.94a1.147 1.147 0 0 0 0 1.946l3.994 2.94a1.144 1.144 0 0 0 1.767-.96v-.667z' />
                        </svg>
                        &nbsp; Regresar
                    </Link>
                </div>
                <div className=''>
                    <div className='col-md-12'>
                        <h5>Información Movimiento</h5>
                        <div className='col-md-12' style={{ display: 'grid' }}>
                            <div className='card mb-2 '>
                                <div className='card-body text-start'>
                                    <div className='row col-md-12'>
                                        <div className='col-md-6'>
                                            <label htmlFor='id'>Almacen {data?.almacen_Destino?.length > 0 ? "Origen" : ""}:</label>
                                            <input
                                                type='text'
                                                className='form-control'
                                                name='folio_Prov'
                                                value={data?.almacen}
                                                disabled={true}
                                            />
                                        </div>
                                        <div className='col-md-6'>
                                            <label htmlFor='id'>Concepto:</label>
                                            <input
                                                type='text'
                                                className='form-control'
                                                name='folio_Prov'
                                                value={data?.concepto_Inventario}
                                                disabled={true}
                                            />
                                        </div>
                                        {data?.almacen_Destino?.length > 0 ? <div className='col-md-6'>
                                            <label htmlFor='id'>Almacen Destino:</label>
                                            <input
                                                type='text'
                                                className='form-control'
                                                name='folio_Prov'
                                                value={data?.almacen_Destino}
                                                disabled={true}
                                            />
                                        </div> : <></>}
                                        <div className='col-md-12'>
                                            <label htmlFor='cp'>Descripcion</label>
                                            <textarea className='form-control' name='descripcion' value={data?.descripcion} disabled={true} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style={{ overflowX: 'auto' }}>
                            <table className='table'>
                                <thead>
                                    <tr>
                                        <th style={{ display: "none" }}>ID</th>
                                        <th className='text-center'>Clave</th>
                                        <th className='text-center'>Articulo</th>
                                        <th className='text-center'>Cantidad</th>
                                        <th className='text-center'>Movimiento</th>
                                        <th className='text-center'>Concepto</th>
                                        <th className='text-center'>Almacen</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data?.movimientos_Inventario_Dets?.map((item) => {
                                        return (<tr key={item.id} >
                                            <td className='text-center' style={{ display: "none" }}>{item.articulo_Id}</td>
                                            <td className='text-center'>{item.clave_Variante || item.clave_Articulo}</td>
                                            <td className='text-center'>{item.nombre_Articulo}</td>
                                            <td className='text-center'>{item.unidades}</td>
                                            <td className='text-center'>{item.tipo_Movimiento}</td>
                                            <td className='text-center'>{item.conceptos_Inv}</td>
                                            <td className='text-center'>{item.almacen}</td>
                                        </tr>);
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>);
};

export { Ver };
